<div class="login">
  <div class="logo-block">
    <img class="logo-block__logo" src="../../assets/images/logo.png" />
    <div class="logo-block__title">Stotrasagar</div>
  </div>
  <form class="white-card login-input">
    <div class="login-input__email">
      <div class="icon-block">
        <svg viewBox="0 0 460.8 460.8" class="icon-block__icon">
          <g>
          <g>
          <path
              d="M230.432,0c-65.829,0-119.641,53.812-119.641,119.641s53.812,119.641,119.641,119.641s119.641-53.812,119.641-119.641
                        S296.261,0,230.432,0z"
              />
          </g>
          </g>
          <g>
          <g>
          <path
              d="M435.755,334.89c-3.135-7.837-7.314-15.151-12.016-21.943c-24.033-35.527-61.126-59.037-102.922-64.784
                                c-5.224-0.522-10.971,0.522-15.151,3.657c-21.943,16.196-48.065,24.555-75.233,24.555s-53.29-8.359-75.233-24.555
                                c-4.18-3.135-9.927-4.702-15.151-3.657c-41.796,5.747-79.412,29.257-102.922,64.784c-4.702,6.792-8.882,14.629-12.016,21.943
                                c-1.567,3.135-1.045,6.792,0.522,9.927c4.18,7.314,9.404,14.629,14.106,20.898c7.314,9.927,15.151,18.808,24.033,27.167
                                c7.314,7.314,15.673,14.106,24.033,20.898c41.273,30.825,90.906,47.02,142.106,47.02s100.833-16.196,142.106-47.02
                                c8.359-6.269,16.718-13.584,24.033-20.898c8.359-8.359,16.718-17.241,24.033-27.167c5.224-6.792,9.927-13.584,14.106-20.898
                                C436.8,341.682,437.322,338.024,435.755,334.89z"
              />
          </g>
          </g>
        </svg>
      </div>
      <input
          [(ngModel)]="email"
          placeholder="Email"
          name="email"
          class="input"
          type="email"
          />
    </div>
    <div class="login-input__password">
      <div class="icon-block">
        <svg
            viewBox="0 0 870.3 870.3"
            class="icon-block__icon"
            >
            <g>
          <path
              d="M561.05,288.9c27.898,11.8,53.699,27.3,77.1,46.2V201.5c0-111.1-90.4-201.5-201.5-201.5h-3.1
                          c-111,0-201.4,90.4-201.4,201.5v133.6c23.4-18.899,49.2-34.399,77.1-46.2c7.5-3.2,15.2-6.1,22.9-8.7v-78.7
                          c0-56,45.5-101.5,101.5-101.5h3.1c56,0,101.5,45.5,101.5,101.5v78.8C545.849,282.8,553.55,285.7,561.05,288.9z"
              />
          <path
              d="M151.75,586.9c0,156.5,126.9,283.399,283.4,283.399c156.5,0,283.401-126.8,283.401-283.399
                            c0-76.9-30.701-146.7-80.4-197.801c-28-28.699-62-51.5-100-66.399c-31.9-12.5-66.701-19.3-103-19.3c-36.3,0-71.1,6.8-103,19.3
                            c-38,14.8-72,37.6-100,66.399C182.35,440.2,151.75,510,151.75,586.9z M362.149,529.7c1-38.7,32.5-70.2,71.2-71.101
                            c41.099-1,74.8,32.101,74.8,73c0,4.301-0.4,8.5-1.1,12.5c-3.602,20.7-15.9,38.5-33.102,49.301c-7.1,4.5-10.699,12.899-8.898,21
                            L486.75,717.3c1.301,6.2-3.4,12.101-9.801,12.101H393.35c-6.4,0-11.101-5.801-9.8-12.101L405.249,614.4
                            c1.7-8.2-1.8-16.601-8.899-21.101c-17.2-10.8-29.5-28.5-33.101-49.3C362.449,539.4,362.05,534.6,362.149,529.7z"
              />
            </g>
        </svg>
      </div>
      <input
          [(ngModel)]="password"
          placeholder="Password"
          class="input"
          type="password"
          name="password"
          />
    </div>
    <button-cmp (click)="onLoginSubmit()" isLogin=true isAdd=false title=login class="login-input__button"></button-cmp>
  </form>
</div>
